(() => {
  const SWATCH_SELECTOR =
    '.grid-product__colors .color-swatch[data-variant-image]:not(.color-swatch--soldout)';

  function cardRoot(el) {
    return (
      el.closest('.grid__item-image-wrapper') ||
      el.closest('.grid__item') ||
      el.closest('.grid-product')
    );
  }

  function mainImg(root) {
    if (!root) return null;

    // Impulse: primary image is the first <img> inside .grid-product__image-mask
    const mask = root.querySelector('.grid-product__image-mask');
    if (mask) {
      const imgs = mask.querySelectorAll('img');
      if (imgs && imgs.length) return imgs[0];
    }

    return (
      root.querySelector('.grid__image-ratio img') ||
      root.querySelector('.image-wrap img') ||
      root.querySelector('img')
    );
  }

  function saveOrig(img) {
    if (!img) return;
    if (!img.dataset.origSrc) img.dataset.origSrc = img.getAttribute('src') || '';
    if (!img.dataset.origSrcset) img.dataset.origSrcset = img.getAttribute('srcset') || '';
    if (!img.dataset.origSizes) img.dataset.origSizes = img.getAttribute('sizes') || '';
    if (!img.dataset.origDataSrc) img.dataset.origDataSrc = img.getAttribute('data-src') || '';
    if (!img.dataset.origDataSrcset)
      img.dataset.origDataSrcset = img.getAttribute('data-srcset') || '';
  }

  function forceSwap(img, url) {
    if (!img || !url) return;
    saveOrig(img);

    // Force src/srcset + common lazyload attrs (Impulse-friendly)
    img.setAttribute('src', url);
    img.setAttribute('srcset', `${url} 900w`);
    img.setAttribute('sizes', '900px');
    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', `${url} 900w`);
  }

  function restore(img) {
    if (!img || !img.dataset.origSrc) return;
    img.setAttribute('src', img.dataset.origSrc);
    img.setAttribute('srcset', img.dataset.origSrcset);
    img.setAttribute('sizes', img.dataset.origSizes);
    img.setAttribute('data-src', img.dataset.origDataSrc);
    img.setAttribute('data-srcset', img.dataset.origDataSrcset);
  }

  function stopAll(e) {
    // Prevent card click + other theme handlers from hijacking
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  function onOver(e) {
    const sw = e.target.closest(SWATCH_SELECTOR);
    if (!sw) return;
    stopAll(e);

    const root = cardRoot(sw);
    const img = mainImg(root);
    if (!img) return;

    forceSwap(img, sw.dataset.variantImage);
  }

  function onOut(e) {
    const sw = e.target.closest(SWATCH_SELECTOR);
    if (!sw) return;
    stopAll(e);

    const root = cardRoot(sw);
    const img = mainImg(root);
    if (!img) return;

    restore(img);
  }

  function onClick(e) {
    const sw = e.target.closest(SWATCH_SELECTOR);
    if (!sw) return;
    stopAll(e);

    const root = cardRoot(sw);
    const img = mainImg(root);
    if (!img) return;

    forceSwap(img, sw.dataset.variantImage);
  }

  // Capture phase: run before Impulse listeners
  document.addEventListener('pointerover', onOver, true);
  document.addEventListener('pointerout', onOut, true);
  document.addEventListener('click', onClick, true);

  // Keyboard (accessibility)
  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const sw = e.target.closest && e.target.closest(SWATCH_SELECTOR);
      if (!sw) return;
      stopAll(e);

      const root = cardRoot(sw);
      const img = mainImg(root);
      if (!img) return;

      forceSwap(img, sw.dataset.variantImage);
    },
    true
  );
})();
